import 'babel-polyfill'

import Vue from 'vue'
import App from './App.vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import svgJS from './plugin/vueSvgPlugin'

Vue.use(svgJS);


import router from './router.js';

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

Vue.mixin({
  methods: {
    elevatorName(e) {
      if (!e) return '';
      return e.name || e.host || '';
    },
  }
})

var vm = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})

window.vue = vm;



// WEBPACK FOOTER //
// ./src/main.js